import { Controller } from "@hotwired/stimulus"

// The Card panel of the card screen (docs/frontend.md). The state travels in
// the URL (`?panel=open`), so every toggle is a working link without
// JavaScript. With it, the same link only flips an attribute — the motion is
// CSS, like the shell's sidebar — and the URL is kept in sync without a
// visit: opening the Card must never cost you your place in a long document.
export default class extends Controller {
  static targets = ["toggle", "panel"]
  static values = { openUrl: String, closedUrl: String }

  toggle(event) {
    event.preventDefault()
    const open = this.element.toggleAttribute("data-card-panel-open")

    // Closed it is out of the keyboard's way, not merely off-screen
    this.panelTarget.toggleAttribute("inert", !open)

    this.toggleTargets.forEach((link) => {
      link.href = open ? this.closedUrlValue : this.openUrlValue
      link.setAttribute("aria-expanded", open)
    })

    history.replaceState(history.state, "", open ? this.openUrlValue : this.closedUrlValue)
  }
}
